import { Capacitor } from '@capacitor/core';

const APP_SAFE_HOSTS = new Set(['emedici.com', 'www.emedici.com']);

export function appUrl(value: string, isNative = Capacitor.isNativePlatform()): string {
    if (!isNative) {
        return value;
    }

    try {
        const url = new URL(value);

        if (!APP_SAFE_HOSTS.has(url.hostname)) {
            return value;
        }

        url.searchParams.set('app', '1');

        return url.href;
    } catch {
        return value;
    }
}
